import { MaintenanceNone } from '@atlassian/mpac-types';
/* Default values for each of the feature flags from `MarketplaceFeatureFlags`. */
export const DEFAULT_MARKETPLACE_FEATURE_FLAGS = {
  replaceCategoriesOnAppTilesWithVendorName: false,
  enableBugBountyProgram: false,
  enableCloudFortifiedAppsDiscovery: false,
  enableWebpImage: false,
  showCustomBackendErrorsFromUpm: false,
  enableFreeStarterTierFilter: false,
  disableAppInstall: false,
  showManageAppRequestAlternativeLayout: false,
  disableAllHostingFromPromotionsDropdown: false,
  reviewsCompliancePrompt: false,
  displayAuditTabInManagePartnerPage: true,
  useAmktFrontendAthreosManagePartners: false,
  enableInContextAppRequest: false,
  showCompatibleSiteProducts: false,
  enableInProductHelpPartnerReporting: false,
  showTrelloProductFilter: false,
  strideHipchatBanners: false,
  showTrustSignalsInManageAppRequests: false,
  showDatePickerOnManagePricingTab: false,
  showBenchmarkingUiDropdown: false,
  showDecomposedReviews: false,
  showQualtricsSurvey: false,
  enableRetryForLicenseDetailsPostInstallation: false,
  enableEmailSubscription: false,
  allowSectionMessageForPartnersForMigrationToCcp: [],
  enableIncludePartnerForAllowSectionMessageForMigrationToCcp: false,
  showAppListingTrustTab: false,
  enableReactivateForgeAppFromEmcee: false,
  enableReactivateForgeAppFromEmceeForHAMS: false,
  enableGoogleAnalytics4Tracking: false,
  enableUserSessionAuthForMpacToEmceeRedirect: false,
  enableNewPartnerContactRole: false,
  showCopyChangesForPartnerContact: false,
  enableDualLicenseToggleInPartnersTable: false,
  enableCloudMigrationToggle: false,
  enableReviewComplianceUi: false,
  enablePrefixCodeSectionForGenericCloudPromotions: false,
  enableBacRedirectionForCcpPromotions: false,
  enableMpacServerEolWarning: false,
  enableJsdToJsm: false,
  enableReportsV2FeedbackCollector: false,
  enableReportsAccessibilityChanges: false,
  enableFiftyKPricingTiers: false,
  showFiftyKAnnouncementModal: false,
  enableHostingSelectionModal: true,
  pollIntervalForConnectApps: 300,
  serverEolAppsWithDcVersion: [],
  showAppSlugInAppListingUrl: false,
  showAiAppsCollectionTile: false,
  useAnalyticsWebClient: false,
  enableServerEolWarningForBambooAndCrowd: false,
  enableNewCategoriesAndKeywordsMessage: false,
  enableDeprecatedInstallationsGQL: false,
  consumePartnerUserApi: false,
  enableServerEos: false,
  useStoreBffForInstallation: false,
  enableV2SearchIndex: false,
  partnersNavigationRefresh: false,
  enablePartnerPaymentsViaConsoleBff: false,
  maintenanceBannerConfiguration: MaintenanceNone,
  privacySecurityTabDataResidency: false,
  useAnalyticsWebClientForPartnerEvents: false
};